/* YourChristmasTree: variant fix.
   A height, color or light that only exists together with another option is never shown as sold out.
   Clicking it switches the other options to the closest tree that does exist. Runs next to theme.js. */
(function () {
  'use strict';
  function sets(root) { return Array.prototype.slice.call(root.querySelectorAll('[data-option]')); }
  function idxOf(fs, n) { var a = fs.getAttribute('data-option-index'); return a !== null && a !== '' ? parseInt(a, 10) : n; }
  function data(root) {
    var el = root.querySelector('[data-product-json]');
    if (!el) return null;
    if (el.__yct === undefined) { try { el.__yct = JSON.parse(el.textContent); } catch (e) { el.__yct = null; } }
    return el.__yct;
  }
  function selected(root, len) {
    var o = [];
    for (var k = 0; k < len; k++) o.push(null);
    sets(root).forEach(function (fs, n) { var c = fs.querySelector('input:checked'); if (c) o[idxOf(fs, n)] = c.value; });
    return o;
  }
  function exact(vs, o) {
    for (var i = 0; i < vs.length; i++) {
      var ok = true;
      for (var j = 0; j < o.length; j++) { if (o[j] != null && vs[i].options[j] !== o[j]) { ok = false; break; } }
      if (ok) return vs[i];
    }
    return null;
  }
  function closest(vs, o, idx) {
    var b = null, s = -Infinity;
    for (var i = 0; i < vs.length; i++) {
      var v = vs[i];
      if (!v.available || v.options[idx] !== o[idx]) continue;
      var sc = 0;
      for (var j = 0; j < o.length; j++) {
        if (j === idx || o[j] == null) continue;
        if (v.options[j] === o[j]) { sc += 1000 - j; continue; }
        var a = parseFloat(v.options[j]), c = parseFloat(o[j]);   // heights: stay as close as possible (9 ft goes to 8 ft, not 6 ft)
        if (!isNaN(a) && !isNaN(c)) sc -= Math.abs(a - c);
      }
      if (sc > s) { s = sc; b = v; }
    }
    return b;
  }
  function money(c) { return window.SL && window.SL.formatMoney ? window.SL.formatMoney(c) : '$' + (c / 100).toFixed(2); }

  function mark(root) {
    var d = data(root);
    if (!d || !d.variants || !d.variants.length) return;
    var vs = d.variants, o = selected(root, vs[0].options.length);
    sets(root).forEach(function (fs, n) {
      var idx = idxOf(fs, n);
      var withPrice = !!fs.querySelector('[data-opt-price]');
      Array.prototype.forEach.call(fs.querySelectorAll('.opt__value'), function (w) {
        var inp = w.querySelector('input');
        if (!inp) return;
        var t = o.slice(); t[idx] = inp.value;
        var v = exact(vs, t) || closest(vs, t, idx);
        w.classList.toggle('is-unavailable', !v || !v.available);
        if (withPrice && v) {
          var pr = w.querySelector('[data-opt-price]');
          if (!pr) {
            var lb = w.querySelector('label');
            if (lb) { pr = document.createElement('span'); pr.className = 'opt__price'; pr.setAttribute('data-opt-price', ''); lb.appendChild(pr); }
          }
          if (pr) pr.textContent = money(v.price);
        }
      });
    });
  }

  /* Capture phase: runs before theme.js reads the options, so it always finds a tree that exists. */
  document.addEventListener('change', function (e) {
    var fs = e.target && e.target.closest ? e.target.closest('[data-option]') : null;
    if (!fs) return;
    var root = fs.closest('[data-product]');
    if (!root) return;
    var d = data(root);
    if (!d || !d.variants || !d.variants.length) return;
    var vs = d.variants, all = sets(root), idx = idxOf(fs, all.indexOf(fs));
    var o = selected(root, vs[0].options.length);
    if (exact(vs, o)) return;
    var v = closest(vs, o, idx);
    if (!v) return;
    all.forEach(function (f, n) {
      var i = idxOf(f, n);
      if (i === idx) return;
      Array.prototype.forEach.call(f.querySelectorAll('input'), function (inp) { if (inp.value === v.options[i]) inp.checked = true; });
    });
  }, true);

  document.addEventListener('variant:change', function (e) {
    var r = e.target && e.target.closest ? (e.target.closest('[data-product]') || e.target) : null;
    if (r && r.querySelector) setTimeout(function () { mark(r); }, 0);
  });
  function init() { Array.prototype.forEach.call(document.querySelectorAll('[data-product]'), mark); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  window.addEventListener('load', init);
  document.addEventListener('shopify:section:load', init);
})();
